import { ReactElement, ReactNode } from "react";
import styles from "./Loading.module.css";

export default function Loading(props: {
  isLoading: boolean;
  children: ReactNode;
  className?: string;
}): ReactElement {
  const className = props.className ? props.className : "";
  return (
    <>
      {props.isLoading ? (
        <>
          <p></p>
          <div className={`${styles.loader} ${className}`}>
            <div className="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </>
      ) : (
        props.children
      )}
    </>
  );
}
